// Umbrales de temperatura ambiente (ADR-025).
//
// Declarados como "provisionales, a validar con el ganadero" en
// ADR-025. La razón de vivir en un módulo compartido es que
// NaveCard (badge "Bien / Temp alta / Temp baja") y SiluetaNave
// (color de alarma de los sensores) los consumen a la vez — antes
// vivían duplicados e inconsistentes (badge con 10/30, silueta con
// 15/30), lo que provocaba que una nave a 12 °C saliera "Bien" en
// el badge pero su sensor apareciera pintado como alarma. Ver
// review de PR #12 (warning 1, sha 98b6e3d).

/** Temperatura mínima (°C) por debajo de la cual el ambiente se
 *  considera fuera de rango. */
export const TEMP_MIN_OK = 10;

/** Temperatura máxima (°C) por encima de la cual el ambiente se
 *  considera fuera de rango. */
export const TEMP_MAX_OK = 30;
